import * as React from "react";
import { ClubCompetitionRequestList } from "../list/ClubCompetitionRequestList";
import { ClubWorkbookRequestList } from "../list/ClubWorkbookRequestList";
export interface IClubFilePageProps {
  clubId: number;
}

export const ClubFilePage: React.FunctionComponent<IClubFilePageProps> = ({ clubId }) => {
  return (
    <>
      <ClubCompetitionRequestList clubId={clubId} />
      <ClubWorkbookRequestList clubId={clubId} />
    </>
  );
};
